/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StepIdentifier } from './StepIdentifier';
import {
    StepIdentifierFromJSON,
    StepIdentifierFromJSONTyped,
    StepIdentifierToJSON,
    StepIdentifierToJSONTyped,
} from './StepIdentifier';
import type { SubscriptionStepDto } from './SubscriptionStepDto';
import {
    SubscriptionStepDtoFromJSON,
    SubscriptionStepDtoFromJSONTyped,
    SubscriptionStepDtoToJSON,
    SubscriptionStepDtoToJSONTyped,
} from './SubscriptionStepDto';

/**
 * State of the subscription process
 * @export
 * @interface SubscriptionProcessStateDto
 */
export interface SubscriptionProcessStateDto {
    /**
     * 
     * @type {StepIdentifier}
     * @memberof SubscriptionProcessStateDto
     */
    currentStepIdentifier: StepIdentifier;
    /**
     * 
     * @type {StepIdentifier}
     * @memberof SubscriptionProcessStateDto
     */
    highestAccessibleStep: StepIdentifier;
    /**
     * True if the contract is signed and process is complete
     * @type {boolean}
     * @memberof SubscriptionProcessStateDto
     */
    isProcessCompleted: boolean;
    /**
     * List of all steps in the subscription process
     * @type {Array<SubscriptionStepDto>}
     * @memberof SubscriptionProcessStateDto
     */
    steps: Array<SubscriptionStepDto>;
}



/**
 * Check if a given object implements the SubscriptionProcessStateDto interface.
 */
export function instanceOfSubscriptionProcessStateDto(value: object): value is SubscriptionProcessStateDto {
    if (!('currentStepIdentifier' in value) || value['currentStepIdentifier'] === undefined) return false;
    if (!('highestAccessibleStep' in value) || value['highestAccessibleStep'] === undefined) return false;
    if (!('isProcessCompleted' in value) || value['isProcessCompleted'] === undefined) return false;
    if (!('steps' in value) || value['steps'] === undefined) return false;
    return true;
}

export function SubscriptionProcessStateDtoFromJSON(json: any): SubscriptionProcessStateDto {
    return SubscriptionProcessStateDtoFromJSONTyped(json, false);
}

export function SubscriptionProcessStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionProcessStateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currentStepIdentifier': StepIdentifierFromJSON(json['currentStepIdentifier']),
        'highestAccessibleStep': StepIdentifierFromJSON(json['highestAccessibleStep']),
        'isProcessCompleted': json['isProcessCompleted'],
        'steps': ((json['steps'] as Array<any>).map(SubscriptionStepDtoFromJSON)),
    };
}

export function SubscriptionProcessStateDtoToJSON(json: any): SubscriptionProcessStateDto {
    return SubscriptionProcessStateDtoToJSONTyped(json, false);
}

export function SubscriptionProcessStateDtoToJSONTyped(value?: SubscriptionProcessStateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentStepIdentifier': StepIdentifierToJSON(value['currentStepIdentifier']),
        'highestAccessibleStep': StepIdentifierToJSON(value['highestAccessibleStep']),
        'isProcessCompleted': value['isProcessCompleted'],
        'steps': ((value['steps'] as Array<any>).map(SubscriptionStepDtoToJSON)),
    };
}

